import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <div id="contact">
      <div className="contactdet">
        <h3 className="pt-5 mt-5">Contact: </h3>
      </div>
      <div className="addressdet">
        <h3 className="pt-5 mt-4">Address: Mira Road(E), Mumbai</h3>
      </div>
      <div className="teldet">
        <h3 className="pt-5 mt-5">Tel: 9867363215</h3>
      </div>
      <div className="emaildet">
        <h3 className="pt-5 mt-5">Mail: zarrar@live.in</h3>
      </div>
    </div>
  );
};

export default Contact;
